<template>
  <div class="container mt-4">

    <!-- 1. الفلاتر (ترم ومادة فقط) -->
    <div class="card shadow-sm mb-4 no-print border-top-primary">
      <div class="card-body py-3">
        <div class="row g-3 align-items-end">
          <div class="col-md-4">
            <label class="fw-bold">الفصل الدراسي</label>
            <select v-model="form.term" @change="getSubjectswithtearm" class="form-control">
              <option value="">-- اختر --</option>
              <option v-for="t in terms" :key="t.id" :value="t">{{ t.name }}</option>
            </select>
          </div>
          <div class="col-md-4">
            <label class="fw-bold">المادة</label>
            <select v-model="form.subject" class="form-control">
              <option value="">-- اختر --</option>
              <option v-for="s in subjects" :key="s.id" :value="s">{{ s.name }}</option>
            </select>
          </div>
          <div class="col-md-4">
            <button @click="fetchAllGroups" class="btn btn-primary w-100 fw-bold" :disabled="loading || !form.subject">
              <span v-if="loading" class="spinner-border spinner-border-sm"></span>
              <span v-else><i class="fas fa-layer-group ms-2"></i> عرض جميع المجموعات</span>
            </button>
          </div>
          <div class="col-12 text-end mt-2">
            <button @click="printPage" class="btn btn-dark px-5" :disabled="allGroupsData.length === 0">
              <i class="fas fa-print ms-2"></i> طباعة الكل
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 2. منطقة التقرير (تتكرر الجداول هنا) -->
    <div id="printMe" v-if="allGroupsData.length > 0">

      <!-- Loop على المجموعات -->
      <div v-for="(groupItem, index) in allGroupsData" :key="index" class="group-section"
        style="page-break-after: always;">

        <div class="card border-0 mb-0">
          <div class="card-body p-0 paper-bg" dir="rtl">
            <div class="header-section mb-4">
              <div class="row align-items-center border-bottom border-3 border-dark pb-3">
                <!-- الجهة الإدارية -->
                <div class="col-4 text-start border-start border-dark">
                  <h5 class="fw-bold mb-1">محافظة شمال سيناء</h5>
                  <h6 class="fw-bold mb-1">مديرية التربية والتعليم</h6>
                  <h6 class="fw-bold">لجنة النظام والمراقبة</h6>
                </div>

                <!-- العام والفصل -->
                <div class="col-4 text-center">
                  <div class="py-2">
                    <h2 class="fw-bold m-0" style="font-family: 'Amiri', serif;">الشهادة الإعدادية</h2>
                    <span class="badge bg-white text-dark border border-dark mt-2 fs-6">
                      {{ form.term ? form.term.name : '' }} - {{ form.term ? form.term.years : '' }}
                    </span>
                  </div>
                </div>

                <!-- بيانات المادة -->
                <div class="col-4 text-end pe-4">
                  <div class="d-flex flex-column gap-2">
                    <div class="d-flex justify-content-between border-bottom border-dark pb-1">
                      <span class="fw-bold">المادة:</span>
                      <span>{{ form.subject ? form.subject.name : '......' }}</span>
                    </div>
                    <div class="d-flex justify-content-between border-bottom border-dark pb-1">
                      <span class="fw-bold">التاريخ:</span>
                      <span>..... / ..... / 2025</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="text-center mb-4">
              <div class="title-box d-inline-block px-5 py-2 border border-2 border-dark rounded-3 shadow-sm bg-white">
                <h3 class="fw-bold m-0">حافظة تسليم أوراق الإجابة </h3>
              </div>
              <div class="mt-3">
            <h4 class="fw-bold">مجموعة رقم: <span class="group-number-badge">{{ groupItem.group_no }}</span></h4>
              </div>
            </div>



            <div class="table-container px-3">
              <table class="table table-bordered border-dark text-center align-middle custom-table mb-0">
                <thead class="bg-light text-dark">
                  <tr style="border-bottom: 3px solid #000;">
                    <th width="15%" class="py-3 fs-5">النموذج</th>
                    <th width="20%" class="py-3 fs-5">العدد (بالأرقام)</th>
                    <th width="65%" class="py-3 fs-5">اسم وتوقيع المستلم</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- صفوف النماذج -->
                  <tr v-for="model in ['أ', 'ب', 'ج', 'د']" :key="model" class="model-row">
                    <td class="fw-bold fs-4 bg-light">[{{ model }}]</td>
                    <td></td> <!-- خانة فارغة للكتابة -->
                    <td></td> <!-- خانة فارغة للتوقيع -->
                  </tr>

                  <!-- صف الإجمالي -->
                  <tr class="total-row" style="border-top: 3px double #000;">
                    <td colspan="2" class="text-end pe-4 fw-bold fs-5 bg-light">
                      جملة الأوراق الموجودة فعلياً بالمجموعة
                    </td>
                    <td class="fw-bold fs-4">{{ 200 - countExcluded(groupItem) }}</td>
                  </tr>

                  <!-- 4. منطقة المستبعدات (الورق غير الموجود) -->
                  <tr>
                    <td colspan="3" class="p-0">
                      <div class="missing-papers-section text-start p-3">
                        <!-- عنوان القسم -->
                        <div class="alert alert-dark text-center p-1 mb-3 border-dark fw-bold">
                          أوراق غير موجودة بالمجموعة (عدد: {{ countExcluded(groupItem) }} ورقة) - لا يتم احتسابها في
                          العدد أعلاه
                        </div>

                        <!-- شبكة الفئات -->
                        <div class="row g-0">
                          <!-- الغياب -->
                          <div class="col-6 p-2 border-end border-dark border-bottom">
                            <div class="category-box">
                              <span class="cat-label bg-danger text-white"> R (G)</span>
                              <div class="cat-content">
                                <div class="cat-content">
                                  <span v-if="!groupItem.student_abs.length">---</span>
                                  <span v-else v-for="(c, i) in groupItem.student_abs" :key="'abs' + i"
                                    class="secret-num fs-5 fw-bold">
                                    <span v-if="i > 0" class="mx-1 text-dark fw-bold">-</span>{{ c.SecretKey | scur }}
                                  </span>
                                </div>
                              </div>
                            </div>
                            </div>
                            <!-- اللغات -->
                            <div class="col-6 p-2 border-bottom border-dark">
                              <div class="category-box">
                                <span class="cat-label bg-primary text-white"> B (L)</span>
                                <div class="cat-content">
                                  <span v-if="!groupItem.student_lang.length">---</span>
                                  <span v-else v-for="(c, i) in groupItem.student_lang" :key="'lang' + i"
                                    class="secret-num fs-5 fw-bold">
                                    <span v-if="i > 0" class="mx-1 text-dark fw-bold">-</span>{{ c.SecretKey | scur }}
                                  </span>
                                </div>
                              </div>
                            </div>

                            <!-- الدمج -->
                      <div class="col-6 p-2 border-end border-dark">
                        <div class="category-box">
                          <span class="cat-label bg-warning text-dark"> A (D)</span>
                          <div class="cat-content">
                                  <span v-if="!groupItem.student_damge.length">---</span>
                                  <span v-else v-for="(c, i) in groupItem.student_damge" :key="'damg' + i"
                                    class="secret-num fs-5 fw-bold">
                                    <span v-if="i > 0" class="mx-1 text-dark fw-bold">-</span>{{ c.SecretKey | scur }}
                                  </span>
                                </div>
                              </div>
                            </div>

                            <!-- لجنة خاصة -->
                      <div class="col-6 p-2">
                        <div class="category-box">
                          <span class="cat-label bg-secondary text-white">D (K)</span>
                          <div class="cat-content">
                                  <span v-if="!groupItem.student_khas.length">---</span>
                                  <span v-else v-for="(c, i) in groupItem.student_khas" :key="'khas' + i"
                                    class="secret-num fs-5 fw-bold">
                                    <span v-if="i > 0" class="mx-1 text-dark fw-bold">-</span>{{ c.SecretKey | scur }}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                      
                       
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

















          </div>

          <div class="footer-section px-4 mt-4">

            <!-- إقرار المستلم -->
            <div class="acknowledgment-box p-3 mb-4 border border-dark rounded-3 bg-light">
              <p class="fw-bold mb-0 text-center lh-lg fs-5">
                أقر أنا / .............................................................. (موجه المادة)
                بأنني استلمت الأوراق الموضحة بعالية (عدد ............. ورقة) وأصبحت في عهدتي الشخصية لحين الانتهاء من
                التصحيح وتسليمها.
              </p>
            </div>

            <!-- التوقيعات العلوية -->
            <div class="row text-center mb-5">
              <div class="col-6">
                <h5 class="fw-bold text-decoration-underline mb-4">لجنة التسليم (الكنترول)</h5>
                <div class="signature-line w-50 mx-auto"></div>
              </div>
              <div class="col-6">
                <h5 class="fw-bold text-decoration-underline mb-4">توقيع المستلم (الموجه)</h5>
                <div class="signature-line w-50 mx-auto"></div>
              </div>
            </div>

            <hr class="border-dark border-3 my-4 opacity-100">

            <!-- إقرار الاستلام بعد التصحيح -->
            <div class="return-section text-center">
              <p class="fw-bold fs-5 mb-4">
                تسلمنا نحن أعضاء الكنترول (حجرة .............) الأوراق الموضحة أعلاه بعد تصحيحها<br>
                كاملة العدد وفي حالة سليمة، وذلك في تمام الساعة ( .................. ).
              </p>

              <div class="row mt-5">
                <div class="col-6">
                  <h5 class="fw-bold">لجنة الاستلام</h5>
                  <div class="d-flex justify-content-center gap-5 mt-4">
                    <span>1- ......................</span>
                    <span>2- ......................</span>
                  </div>
                </div>
                <div class="col-6">
                  <h5 class="fw-bold">رئيس الحجرة / الكنترول</h5>
                  <p class="mt-4">........................................</p>
                </div>
              </div>
            </div>

          </div>

        </div>

      </div> <!-- نهاية Loop المجموعة -->

    </div>
  </div>
</template>

<script>
import api from '@/api/axios';
import ControlFilters from '@/components/ControlFilters.vue';

export default {
  components: { ControlFilters },
  data() {
    return {
      loading: false,
      terms: [],
      subjects: [],
      allGroupsData: [], // المصفوفة التي ستحتوي على بيانات كل المجموعات
      form: { term: "", subject: "" },
    };
  },
  mounted() {
    api.get("/getterms").then((res) => { this.terms = res.data; });
  },
  filters: {
    scur(value) {
      if (!value) return '';
      value = value.toString();
      return parseInt(value.slice(-3)) || '';
    }
  },
  methods: {
    getSubjectswithtearm() {
      if (!this.form.term) return;
      api.get("/getSubject/" + this.form.term.id).then((res) => {
        this.subjects = res.data;
      });
    },

    // دالة جلب كل المجموعات
    fetchAllGroups() {
      this.loading = true;
      this.allGroupsData = [];

      api.post('/countStatisticsAll', {
        term: this.form.term,
        subject: this.form.subject
      })
        .then(res => {
          this.allGroupsData = res.data;
        })
        .catch(e => alert("حدث خطأ"))
        .finally(() => this.loading = false);
    },

    // دالة مساعدة لحساب العدد (الغياب + الدمج + ...)
    countExcluded(groupItem) {
      return (groupItem.student_abs?.length || 0) +
        (groupItem.student_lang?.length || 0) +
        (groupItem.student_damge?.length || 0) +
        (groupItem.student_khas?.length || 0);
    },

    printPage() {
      this.$htmlToPaper("printMe");
    },
  }
};
</script>

<style scoped>
  .group-number-badge { background-color: #000; color: #fff; padding: 2px 15px; border-radius: 50px; font-family: 'Arial'; }
.container {
  direction: rtl;
  text-align: right;
}

.report-container {
  width: 100%;
  padding: 20px;
  font-family: "Cairo", sans-serif;
  color: #222;
}

.report-header {
  text-align: center;
  margin-bottom: 25px;
}

.report-header h2 {
  margin: 0;
  font-size: 24px;
  font-weight: bold;
}

.report-header .sub {
  font-size: 14px;
  color: #555;
}

.table-report {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  font-size: 15px;
}

.table-report thead {
  background: #f1f1f1;
}

.table-report th {
  padding: 10px 8px;
  text-align: center;
  border: 1px solid #ccc;
  font-weight: 700;
}

.table-report td {
  padding: 9px 6px;
  border: 1px solid #ddd;
  text-align: center;
}

.table-report tbody tr:nth-child(even) {
  background: #fafafa;
}

.table-report tbody tr:hover {
  background: #eef5ff;
}

.footer-note {
  margin-top: 30px;
  text-align: left;
  font-size: 13px;
  color: #777;
}

.table td,
.table th {
  border-top: 1px solid #000000 !important;
  border-left: 1px solid #000000 !important;
}

.table thead th {
  background-color: #afafaf !important;

  border-bottom: 2px solid #000000 !important;
}

.table-bordered td,
.table-bordered th {
  border: 1px solid #000000 !important;
  padding: 10px !important;
}

.p-d {
  border: 2px dashed black;
}
</style>